import React from "react";
import { Checkbox } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import DetalheExame from "./DetalheExame";
import { formatarValor } from "../../../utils/formatarValor";

// Componente isolado para cada item da lista - otimização crítica
const ExameItem = React.memo(({ 
  exame, 
  index, 
  totalExames,
  isExpandido, 
  isSelecionado, 
  onToggleExpandir, 
  onToggleSelecao 
}) => {
  const handleClick = () => onToggleExpandir(exame.id);

  const handleCheckboxChange = (e) => onToggleSelecao(exame.id, e);

  const handleCheckboxClick = (e) => e.stopPropagation();

  return (
    <div>
      <div 
        className={`exameItem ${index === 0 ? 'first' : ''} ${index === totalExames - 1 && !isExpandido ? 'last' : ''} ${isExpandido ? 'expanded' : ''}`}
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
      >
        <Checkbox 
          size="small" 
          checked={isSelecionado}
          onChange={handleCheckboxChange}
          onClick={handleCheckboxClick}
        />
        <div className="exameItemContentWrapper">
          <div className="exameItemContent">
            {exame.nome}
          </div>
          <div className="exameItemPreco">
            {exame.preco ? formatarValor(parseFloat(exame.preco) || 0) : 'Consultar preço'}
          </div>
        </div>
        {isExpandido ? (
          <KeyboardArrowUpIcon className="exameItemArrow" />
        ) : (
          <KeyboardArrowDownIcon className="exameItemArrow" />
        )}
      </div>
      <div className={`exameItemDetalhes ${isExpandido ? 'expanded' : ''}`}>
        {isExpandido && <DetalheExame id={exame.id} preco={exame.preco} />}
      </div>
    </div>
  );
});

ExameItem.displayName = 'ExameItem';

export default ExameItem;

